import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PermissionService } from 'src/app/core/services/auth/permission.service';
import { SsoApiService } from 'src/app/core/services/http/sso-api.service';
import { SessionStoreService } from 'src/app/core/services/stores/session-store.service';
import { externalLoadingHtml } from 'src/app/shared/constants/externalLoading.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
  standalone: false
})
export class SsoComponent implements AfterViewInit {

  constructor(
    private permissionService: PermissionService,
    private activatedRoute: ActivatedRoute,
    private ssoApiService: SsoApiService,
    private sessionStore: SessionStoreService,
  ) { }
  externalLoadingHtml = externalLoadingHtml;
  isError = false;
  environment = environment;

  ngAfterViewInit(): void {
    const onBehalfOfUserId = this.activatedRoute.snapshot.queryParamMap.get('onBehalfOfUserId');
    const accessToken = this.activatedRoute.snapshot.queryParamMap.get('accessToken');
    if (!accessToken) {
      this.isError = true;
    } else {
      this.permissionService.clearAllLocalStorage();
      if (onBehalfOfUserId) this.permissionService.setOnBehalfOfUserId(onBehalfOfUserId);
      this.ssoIntoPortal(accessToken);
    }
  }

  ssoIntoPortal(accessToken: string): void {
    this.ssoApiService.initiatePortalSso(accessToken).subscribe({
      next: () => {
        this.sessionStore.clearSessionStoreLocalStorage();
        const releaseDate = new Date(2026, 2, 16); // Month is 0-based (2 = March)
        const canSeeNewPortal = new Date() >= releaseDate || !environment.production;
        window.location.href = window.location.origin + (canSeeNewPortal ? '/v2/home' : '/Portal/Dashboard');
      },
      error: () => {
        this.isError = true;
      }
    });
  }
}
